export const URLParams = ['p', 'q', 'resultsPP', 'order', 'dir', 'id', 'qs']

/**
 * Query param object
 * @returns {Object} key: [values]
 */
export function parseQueryParams(query = {}) {
    const params = { ...query }

    for (const [key, value] of Object.entries(params)) {
        params[key] = value.split(',')
    }

    return params
}

/**
 * Get parameters from current URL
 * @returns {Object} params
 */
export function getURLParams(query) {
    const params = {}
    for (const [k, v] of Object.entries(query)) {
        if (URLParams.includes(k)) {
            params[k] = /order|dir|q/.test(k) ? v : Number(v)
        }
    }

    return params
}

/**
 * Get parameters from store and set URL
 * @param {Object} params
 */
export function setURLParams(params) {
    if (typeof window === 'undefined') {
        return true
    }
    const url = new URL(document.location);
    const searchParams = new URLSearchParams(url.search);

    if (params.p > 1) {
        searchParams.set('p', params.p.toString());
    } else {
        searchParams.delete('p');
    }

    Object.keys(params).forEach(function (key) {
        if (key !== 'p') {
            const value = key;
            if (typeof value !== 'undefined' && params[key]) {
                searchParams.has(value)
                    ? searchParams.set(value, params[key])
                    : searchParams.append(value, params[key]);
            } else {
                searchParams.delete(value);
            }
        }
    });

    // replace params
    window.history.replaceState(
        {},
        '',
        `${location.pathname}${searchParams.toString() ? '?' + searchParams.toString() : ''}`
    );
}

/**
 * Parse and get filters object
 * @param {Object} queryObject
 * @returns {Object}  key: [values]
 */
export function getURLFilters(query) {
    const queryObject = {}

    for (const [k, v] of Object.entries(query)) {
        if (!URLParams.includes(k)) {
            let value = ''
            if (k === 'price') {
                value = [v]
            } else {
                value = v.split(',')
            }
            queryObject[k] = value
        }
    }

    return queryObject
}

/**
 * Get filters from store and set URL
 * @param {Object} filters
 */
export function setURLFilters(filters) {
    const url = new URL(document.location)
    const searchParams = new URLSearchParams(url.search)

    Object.keys(filters).forEach(function (filter) {
        if (filters[filter].length) {
            searchParams.has(filter)
                ? searchParams.set(filter, filters[filter])
                : searchParams.append(filter, filters[filter])
        } else {
            searchParams.delete(filter)
        }
    })

    // check if searchParams has some attributes which doesn't exist
    for (let k of Array.from(searchParams.keys())) {
        if (!filters[k] && !URLParams.includes(k)) {
            searchParams.delete(k)
        }
    }

    window.history.replaceState({}, '', `${location.pathname}?${searchParams}`)
}
